document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('[data-modal-root]');
  const floatButton = document.querySelector('[data-modal-float]');
  const floatHideButton = document.querySelector('[data-modal-float-hide]');
  if (!modal || !floatButton) return;

  const loggedIn = document.body.dataset.customerLoggedIn === 'true';
  if (loggedIn) return;

  const STORAGE_KEY = 'pc_welcome_modal_state';
  const hiddenClasses = ['tw:opacity-0', 'tw:pointer-events-none'];
  let lastActiveElement = null;
  let isOpen = false;

  const getState = () => localStorage.getItem(STORAGE_KEY) || 'initial';
  const setState = (state) => localStorage.setItem(STORAGE_KEY, state);

  const setToggleVisibility = (element, visible) => {
    if (!element) return;
    if (visible) {
      element.classList.remove(...hiddenClasses);
      element.removeAttribute('aria-hidden');
      element.removeAttribute('tabindex');
      return;
    }
    element.classList.add(...hiddenClasses);
    element.setAttribute('aria-hidden', 'true');
    element.setAttribute('tabindex', '-1');
  };

  const showFloatButtons = () => {
    setToggleVisibility(floatButton, true);
    setToggleVisibility(floatHideButton, true);
  };

  const hideFloatButtons = () => {
    setToggleVisibility(floatButton, false);
    setToggleVisibility(floatHideButton, false);
  };

  const setModalFocus = () => {
    const initialFocus =
      modal.querySelector('[data-modal-initial-focus]') ||
      modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');

    if (typeof trapFocus === 'function') {
      trapFocus(modal, initialFocus || modal);
      return;
    }

    if (initialFocus) {
      initialFocus.focus();
    }
  };

  const releaseModalFocus = (fallbackFocus) => {
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus();
    }

    const canFocus = (element) =>
      element &&
      document.contains(element) &&
      element.getAttribute('aria-hidden') !== 'true';

    if (canFocus(fallbackFocus)) {
      fallbackFocus.focus();
      return;
    }

    if (canFocus(lastActiveElement) && !modal.contains(lastActiveElement)) {
      lastActiveElement.focus();
    }
  };

  const onModalKeydown = (event) => {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    event.preventDefault();
    minimizeModal();
  };

  const openModal = () => {
    lastActiveElement = document.activeElement;
    modal.classList.remove('tw:opacity-0', 'tw:pointer-events-none');
    modal.classList.add('tw:opacity-100');
    modal.setAttribute('aria-hidden', 'false');
    modal.removeAttribute('inert');

    hideFloatButtons();
    setModalFocus();

    if (!isOpen) {
      document.addEventListener('keydown', onModalKeydown);
      isOpen = true;
    }
  };

  const minimizeModal = () => {
    modal.classList.remove('tw:opacity-100');
    modal.classList.add('tw:opacity-0', 'tw:pointer-events-none');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('inert', '');

    showFloatButtons();
    releaseModalFocus(floatButton);
    if (isOpen) {
      document.removeEventListener('keydown', onModalKeydown);
      isOpen = false;
    }
    setState('minimized');
  };

  const hideAll = () => {
    modal.classList.remove('tw:opacity-100');
    modal.classList.add('tw:opacity-0', 'tw:pointer-events-none');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('inert', '');

    hideFloatButtons();
    releaseModalFocus();
    if (isOpen) {
      document.removeEventListener('keydown', onModalKeydown);
      isOpen = false;
    }
  };

  // 初期状態を見て挙動を決める
  const state = getState();

  if (state === 'completed' || state === 'hidden') {
    hideAll();
    return;
  }

  if (state === 'minimized') {
    // すでに閉じられている場合はフロートだけ出しておく
    showFloatButtons();
  } else {
    // 初回は数秒後にモーダルを表示。その時点で診断モーダルが開いていたら重ねず、フロートだけ出す
    // （状態は変えないので、次のページでは通常どおり表示される）
    setTimeout(() => {
      const diagnosis = document.getElementById('pc-diagnosis-modal');
      if (diagnosis && diagnosis.getAttribute('aria-hidden') === 'false') {
        showFloatButtons();
        return;
      }
      openModal();
    }, 3000);
  }

  // モーダルの「×」「あとで考える」など → 最小化
  modal.querySelectorAll('[data-modal-minimize], [data-modal-close]').forEach((el) => {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      minimizeModal();
    });
  });

  // フロートをクリックしたらモーダルを再表示
  floatButton.addEventListener('click', () => {
    openModal();
  });

  // フロートを今後表示しない
  if (floatHideButton) {
    floatHideButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setState('hidden');
      hideAll();
    });
  }

  // フォーム送信時は completed 扱いにして以降出さない
  const form = modal.querySelector('form');
  if (form) {
    form.addEventListener('submit', () => {
      setState('completed');
      // リダイレクト後はJSが再読込されるので、ここではhideAllだけでOK
      hideAll();
    });
  }
});
